import {createContext, useContext, useEffect, useState} from "react";
import AuthService from "../components/services/AuthService";
import { Buffer } from 'buffer';

const AuthContext = createContext();

const AuthProvider = ({children}) => {
    const [currentUser, setCurrentUser] = useState(null);
    const handleSignIn = (username, password) => {
        AuthService.signIn(username, password).then(response => {
            const data = getSignInData(response.data);
            localStorage.setItem("Authorization", JSON.stringify(data));
        })
    }

    const handleSignOut = () => {
        
    }


    const getSignInData = (jsonData) => {
        const idToken = JSON.parse(Buffer.from(jsonData.id_token.split('.')[1], 'base64').toString())
        
        return {
            userId: idToken.sub,
            token: jsonData.access_token,
            refreshToken: jsonData.refresh_token ?? null
        }
    }
    
    return (
        <AuthContext.Provider value={{handleSignIn}}>
            {children}
        </AuthContext.Provider>
    )
}

export default AuthProvider;

export const useAuthorization = () => useContext(AuthContext);